export default __webpack_public_path__ + "static/media/obamacare.431c5586.jpg";